import styled, { css } from 'styled-components';
import { remCalc } from '@prisjakt/ui-base';

type RatingProps = {
  showPriceListRatingExperiment: boolean;
  scoreVisibility?: 'row' | 'compact';
  size?: 'small' | 'normal';
};

export const RatingExperiment = styled.div.attrs({
  'data-test': 'Rating',
})<RatingProps>(
  props => css`
    display: none;

    ${props.showPriceListRatingExperiment &&
      css`
        display: flex;
        align-items: center;
      `}

    ${props.scoreVisibility === 'compact' &&
      css`
        &::after {
          content: attr(data-rating);
          position: absolute;
          bottom: -8px;
          left: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 13px;
          border-radius: 8px;
          font-size: 10px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          background: ${props.theme.ratings.disabled.bg};
          color: ${props.theme.ratings.disabled.fg};
        }
      `}

    ${props.scoreVisibility === 'row' &&
      css`
        &::after {
          content: attr(data-rating);
          display: inline;
          line-height: 1.4;
          font-size: ${remCalc(14)};
          margin-left: 0.5em;
          color: ${p => p.theme.text.secondary};

          ${props.size === 'small' &&
            css`
              font-size: ${remCalc(12)};
            `}
        }
      `}
  `
);

export const RatingSmiley = styled.div`
  position: relative;
`;
